<template>
  <div v-if="subscriptions" :class="{ updating: saveInProgress }">
    <CancelSubscriptionModal
      v-if="isCancelSubscriptionModalOpen"
      modelValue="isCancelSubscriptionModalOpen"
      :subscriptionId="subscriptionToCancelId"
      :cancelError="cancelSubscriptionErrorMessage"
      @cancel-subscription="cancelSubscription"
      @toggle-cancel-subscription-modal="toggleCancelSubscriptionModal"
    />
    <div class="subs-list-container">
      <h4>Subscriptions:</h4>
      <div class="filter-input">
        <label for="display-cancelled">Display cancelled subscriptions?</label>
        <input type="checkbox" v-model="displayCancelledSubscriptions" id="display-cancelled" />
      </div>
      <ul class="subs-list">
        <li
          v-for="sub in filteredSubscriptions"
          :key="sub.id"
          @click.stop="setActiveSubscription(sub)"
          :class="{ active: isActive(sub.id) }"
          data-test="subscription-list-item"
        >
          {{ getSubscriptionDisplayName(sub) }}
          <a
            v-if="isActive(sub.id)"
            href="javascript:void(0)"
            class="ml-2"
            @click="openCancelSubscriptionModal(sub.id)"
            >Cancel</a
          >
        </li>
      </ul>
    </div>
    <div v-if="activeSubscription">
      <div class="data-export">
        <a
          :href="`/admin/crmexport/subscriptiondata/${activeSubscription.id}`"
          data-test="subscription-data-export-link"
          >Data Export</a
        >
      </div>
      <table class="table">
        <tbody>
          <tr>
            <th>Package</th>
            <td data-test="plan-title">{{ planTitle }}</td>
          </tr>
          <tr>
            <th>Start date</th>
            <td data-test="sub-start-date">{{ subscriptionStartDate }}</td>
          </tr>
          <tr v-if="activeSubscription.subscriptionEndTime">
            <th>
              End date
              <span v-if="isJyreAssess">(Deadline for Assess subscriptions)</span>
            </th>
            <td data-test="sub-end-date">
              <div v-show="!isEditingDeadline">
                {{ subscriptionEndDate }}
                <a
                  v-show="isJyreAssess"
                  href="#"
                  @click="toggleEditDeadline"
                  data-test="sub-edit-end-date"
                  ><span class="text-sm glyphicon glyphicon-pencil"></span
                ></a>
              </div>
              <!--              <div v-show="isEditingDeadline" id="toggle-edit-end-date">-->
              <!--                <form @submit.prevent="updateAssessDeadline" class="deadline-form">-->
              <!--                  <label for="new-end-date" />-->
              <!--                  <input-->
              <!--                    type="date"-->
              <!--                    :min="dayAfterTomorrow"-->
              <!--                    id="new-end-date"-->
              <!--                    v-model="newDeadline"-->
              <!--                    data-test="new-end-date-input"-->
              <!--                  />-->
              <!--                  <button-->
              <!--                    type="submit"-->
              <!--                    class="btn btn-primary"-->
              <!--                    data-test="submit-new-end-date-button"-->
              <!--                  >-->
              <!--                    Submit-->
              <!--                  </button>-->
              <!--                  <button class="btn btn-default" @click="closeEditingDeadline">Cancel</button>-->
              <!--                </form>-->
              <!--                <p v-if="assessDeadlineError.length" class="text-danger">-->
              <!--                  {{ assessDeadlineError }}-->
              <!--                </p>-->
              <!--              </div>-->
            </td>
          </tr>
          <tr v-if="activeSubscription.billingCycle">
            <th>Billing cycle</th>
            <td data-test="sub-billing-cycle">
              {{ activeSubscription.billingCycle }}
            </td>
          </tr>
          <tr>
            <th>Invite code</th>
            <td>
              <a href="javascript:void(0)" @click="copyInviteCode" data-test="sub-invite-code">{{
                inviteCode
              }}</a>
            </td>
          </tr>
          <tr>
            <th>Status</th>
            <td data-test="sub-status">{{ activeSubscription.status }}</td>
          </tr>
          <tr>
            <th>Owner</th>
            <td>
              <div v-if="activeSubscription.owner">
                <a
                  :href="'/admin/user/details/' + activeSubscription.owner.id"
                  data-test="sub-owner"
                  >{{ activeSubscription.owner?.firstName }}
                  {{ activeSubscription.owner?.lastName }}</a
                >
              </div>
              <div v-else data-test="sub-no-owner">This is a managed subscription</div>
            </td>
          </tr>
          <tr>
            <th>Allow Open Invites</th>
            <td>
              <div class="input-wrapper">
                <label class="switch">
                  <input
                    type="checkbox"
                    @change="onToggleOpenInviting"
                    :checked="openInviteState"
                  />
                  <span class="slider round" />
                </label>
                <p v-if="openInviteSettingError.length">{{ openInviteSettingError }}</p>
              </div>
            </td>
          </tr>
          <tr>
            <th>Total licences</th>
            <td>
              <div class="licence-count">
                <div v-show="!isEditingLicenceCount" data-test="sub-total-licences">
                  {{ updatedLicenceCount ?? licenceCount }}
                  <a
                    href="javascript:void(0)"
                    @click="toggleEditLicenceCount"
                    data-test="sub-edit-licences"
                    ><span class="text-sm glyphicon glyphicon-pencil"></span
                  ></a>
                </div>
                <!--                <div v-if="isEditingLicenceCount">-->
                <!--                  <form @submit.prevent="updateLicenceCount" method="post">-->
                <!--                    <input-->
                <!--                      type="number"-->
                <!--                      v-model="editedLicenceCount"-->
                <!--                      id="edit-licence-count"-->
                <!--                      :disabled="!isEditingLicenceCount"-->
                <!--                      aria-labelledby="edit-licence-count-label"-->
                <!--                      data-test="edit-licence-count-input"-->
                <!--                    />-->
                <!--                    <label for="edit-licence-count" class="visually-hidden"-->
                <!--                      >Edit licence count</label-->
                <!--                    >-->
                <!--                    <button type="submit" class="btn btn-primary" data-test="submit-licence-count">-->
                <!--                      Confirm-->
                <!--                    </button>-->
                <!--                    <button class="btn btn-default" @click="closeEditing">Cancel</button>-->
                <!--                  </form>-->
                <!--                  <p v-if="licenceUpdateError.length" class="text-danger">-->
                <!--                    {{ licenceUpdateError }}-->
                <!--                  </p>-->
                <!--                </div>-->
              </div>
            </td>
          </tr>
          <tr>
            <th>Used licences</th>
            <td data-test="sub-licence-use">
              {{ activeSubscription.licences.length }}
              <span style="font-style: italic">({{ availableLicences }})</span>
            </td>
          </tr>
          <tr>
            <th>Chargebee Subscription Id</th>
            <td data-test="sub-chargebee-id">{{ activeSubscription.chargebeeSubscriptionId }}</td>
          </tr>
          <tr>
            <th>Chargebee Customer Id</th>
            <td data-test="sub-chargebee-customer">{{ activeSubscription.chargebeeCustomerId }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div v-else><h4>Organisation has no licences</h4></div>
</template>

<script setup lang="ts">
import moment from "dayjs";
import { computed, ref } from "vue";
import axios, { AxiosError } from "axios";
import CancelSubscriptionModal from "./cancel-subscription-modal.vue";
import { jyreSubscriptionUids } from "../../../typings/enums/jyre-subscription-uids";
import { ChargebeeSubscriptionApiModel } from "../../../api-models";
import { useToggle } from "../../../composables/useToggle";

const props = defineProps<{ subscriptions?: ChargebeeSubscriptionApiModel[] }>();
const emit = defineEmits(["revalidate-org-data"]);

const displayCancelledSubscriptions = ref(false);

const filteredSubscriptions = computed(() => {
  return displayCancelledSubscriptions.value
    ? props.subscriptions
    : props.subscriptions?.filter((sub) => sub.status !== "Cancelled");
});

const activeSubscription = ref<ChargebeeSubscriptionApiModel | undefined>(
  props.subscriptions?.length ? filteredSubscriptions.value![0] : undefined,
);

const licenceUpdateError = ref("");
const openInviteSettingError = ref("");
const saveInProgress = ref(false);

const { state: isEditingLicenceCount, toggleState: toggleEditLicenceCount } = useToggle(false);

const { state: isCancelSubscriptionModalOpen, toggleState: toggleCancelSubscriptionModal } =
  useToggle(false);

const initialOpenInviteState = computed(() => {
  return activeSubscription.value?.allowOpenInviting ?? false;
});

const { state: openInviteState, toggleState: toggleOpenInviteState } = useToggle(
  initialOpenInviteState.value,
);

const licenceCount = computed(() => {
  return activeSubscription.value?.currentPaidLicenceCount;
});

const editedLicenceCount = ref(licenceCount.value);

const updatedLicenceCount = ref();

const { state: isEditingDeadline, toggleState: toggleEditDeadline } = useToggle(false);

const newDeadline = ref("");

const assessDeadlineError = ref("");

const dayAfterTomorrow = moment().add(2, "day").format("YYYY-MM-DD");

const cancelSubscriptionErrorMessage = ref<string | null>(null);

const subscriptionToCancelId = ref<string | null>(null);

const planTitle = computed(() => {
  const packageUid = activeSubscription.value ? activeSubscription.value?.prismicPackageUid : "";

  return packageUid
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
});

const getProductType = (subscription: ChargebeeSubscriptionApiModel) => {
  switch (subscription.prismicPackageUid) {
    case jyreSubscriptionUids.ASSESS:
      return "Assess";
    case jyreSubscriptionUids.PRO_TEAMS_PLAN:
      return "Perform";
    case jyreSubscriptionUids.FREE_PLAN:
      return "Free Plan";
    default:
      return "Unknown";
  }
};

const getSubscriptionDisplayName = (subscription: ChargebeeSubscriptionApiModel) => {
  const subscriptionName = subscription.subscriptionName
    ? subscription.subscriptionName
    : getProductType(subscription);
  return `${subscriptionName} - ${subscription.status}`;
};

const subscriptionStartDate = computed(() => {
  return activeSubscription.value
    ? moment(activeSubscription.value?.subscriptionStartTime).format("DD/MM/YYYY")
    : "";
});

const subscriptionEndDate = computed(() => {
  if (!activeSubscription.value) return "";

  let endMoment = moment(activeSubscription.value?.subscriptionEndTime);
  if (activeSubscription.value?.prismicPackageUid === jyreSubscriptionUids.ASSESS) {
    endMoment = endMoment.add(activeSubscription.value?.remainingBillingCycles ?? 0, "day");
  }

  return endMoment.format("DD/MM/YYYY");
});

const inviteCode = computed(() => {
  const code = activeSubscription.value ? activeSubscription.value?.inviteCode : "";

  if (window.location.href.includes("localhost")) {
    return `http://localhost:8080/invites/${code?.toLowerCase()}`;
  }
  if (window.location.href.includes("test")) {
    return `https://characterscope-test.azurewebsites.net/invites/${code?.toLowerCase()}`;
  }
  return `https://app.gyreteams.com/invites/${code.toLowerCase()}`;
});

const availableLicences = computed(() => {
  return activeSubscription.value
    ? `${
        (updatedLicenceCount.value! ?? licenceCount.value!) -
        activeSubscription.value?.licences.length
      } available`
    : "";
});

const setActiveSubscription = (subscription: ChargebeeSubscriptionApiModel) => {
  activeSubscription.value = subscription;
};

const isActive = (id: string) => {
  return activeSubscription.value?.id === id;
};

const copyInviteCode = async () => {
  try {
    await navigator.clipboard.writeText(inviteCode.value);
    // eslint-disable-next-line no-alert
    alert("Invite code copied to clipboard!");
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert("Cannot copy");
  }
};

const closeEditing = () => {
  licenceUpdateError.value = "";
  editedLicenceCount.value = licenceCount.value;
  toggleEditLicenceCount();
};

const updateLicenceCount = async () => {
  if (!editedLicenceCount.value) return;

  saveInProgress.value = true;
  try {
    const response = await axios.post(
      `/api/admin/updatelicencecount/${
        activeSubscription.value?.id
      }?newLicenceCount=${+editedLicenceCount.value}`,
    );
    updatedLicenceCount.value = response.data as number;
    toggleEditLicenceCount();
    saveInProgress.value = false;
  } catch (e) {
    licenceUpdateError.value = (e as AxiosError).response?.data ?? "Error updating licence count";
    saveInProgress.value = false;
  }
};

const isJyreAssess = computed(() => {
  return activeSubscription.value?.prismicPackageUid === jyreSubscriptionUids.ASSESS;
});

const updateAssessDeadline = async () => {
  if (newDeadline.value.length < 1) return;
  const id = activeSubscription.value?.id;
  const endDate = moment(newDeadline.value).format("DD/MM/YYYY");

  saveInProgress.value = true;
  try {
    await axios.post(`/api/admin/updateassessdeadline/${id}?deadline=${endDate}`);
    toggleEditDeadline();
    emit("revalidate-org-data");
    saveInProgress.value = false;
  } catch (e) {
    assessDeadlineError.value = (e as AxiosError).response?.data ?? "Error updating deadline";
    saveInProgress.value = false;
  }
  newDeadline.value = "";
};

const closeEditingDeadline = () => {
  assessDeadlineError.value = "";
  toggleEditDeadline();
};

const onToggleOpenInviting = async () => {
  openInviteSettingError.value = "";
  saveInProgress.value = true;
  try {
    await axios.post(
      `/api/admin/updateopeninviting/${
        activeSubscription.value?.id
      }?allowOpenInviting=${!openInviteState.value}`,
    );
    toggleOpenInviteState();
  } catch (e) {
    openInviteSettingError.value =
      (e as AxiosError).response?.data ?? "Error updating open invite setting";
  } finally {
    saveInProgress.value = false;
  }
};

const openCancelSubscriptionModal = (id: string) => {
  subscriptionToCancelId.value = id;
  toggleCancelSubscriptionModal();
};

const cancelSubscription = async (id: string) => {
  subscriptionToCancelId.value = id;
  saveInProgress.value = true;
  try {
    await axios.post(`/api/admin/cancelsubscription?subscriptionId=${id}`);
    toggleCancelSubscriptionModal();
    emit("revalidate-org-data");
  } catch (e) {
    cancelSubscriptionErrorMessage.value = "There was an error cancelling the subscription";
  } finally {
    saveInProgress.value = false;
  }
};
</script>

<style scoped lang="less">
@import (reference) "../../../styles/bootstrap/variables.less";

.updating {
  opacity: 0.5;
  cursor: wait;

  & > * {
    user-select: none;
    pointer-events: none;
  }
}

.licence-count {
  display: flex;
  align-items: center;

  label,
  input,
  button {
    margin-right: 0.5rem;
  }

  input {
    width: 50px;
  }
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}

.input-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  p {
    margin: 0;
  }
}

.deadline-form {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.subs-list-container {
  margin: 2rem 0;
}

@active-color: rgba(176, 187, 54, 0.8);
@active-hover-color: #f8f8f8;

.subs-list {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    padding: 1rem;
    margin-bottom: 1rem;
    border-radius: 0.75rem;

    &:hover {
      cursor: pointer;
    }

    &:hover:not(.active) {
      background-color: @active-hover-color;
    }
  }
}

.filter-input {
  label {
    margin-right: 1rem;
    font-weight: normal;
  }

  input {
    accent-color: @brand-primary;
  }

  label,
  input {
    &:hover {
      cursor: pointer;
    }
  }

  margin-bottom: 2rem;
}

.active {
  border: 1px solid @active-color;
  font-weight: bold;
}

.data-export {
  padding: 0 1rem 2rem;
}

.ml-2 {
  margin-left: 2rem;
}

/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 7rem;
  height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #d9d9d9;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: @transformational-color;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(3.6rem);
  -ms-transform: translateX(3.6rem);
  transform: translateX(3.6rem);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  width: 7rem;
}

.slider.round:before {
  border-radius: 50%;
}
</style>
